import { createFileRoute } from "@tanstack/react-router"
import type { Uuid } from "@/utils"
import { WorkflowPage } from "@/workflow"

export const Route = createFileRoute("/(user)/t/$tenantSlug/workflows/$id")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      revision?: string
      runId?: Uuid
      history?: true
    },
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { revision, runId, history } = Route.useSearch()

  return (
    <WorkflowPage
      id={id}
      revisionIdOrTag={revision}
      runId={runId}
      history={!!history}
    />
  )
}
